<input type="text"
       maxlength="5"
       aria-label="Varighet"
       placeholder="{{placeholder}}"
       (focus)="vedFokusMottatt()"
       (blur)="vedFokusMistet()"
       [formControl]="klokkeslettTekstfelt"
       [matAutocomplete]="autoCompleteKomponent"
       data-testid="varighet-felt"
       #tekstfelt>
@if (formatertVarighet() != null) {
  <span class="varighet">({{ formatertVarighet() | duration }})</span>
}
<mat-autocomplete
        class="varighet-velger--valg"
        panelWidth="200px"
        hideSingleSelectionIndicator="true"
        autoSelectActiveOption="true"
        #autoCompleteKomponent="matAutocomplete"
        (opened)="vedNedtrekksmenyAapnet()">
  @for (innslag of predefinerteVarigheter(); track innslag.klokkeslett) {
    <mat-option [value]="innslag.klokkeslett">
      {{ plainTimeTilStreng(innslag.klokkeslettSomPlainTime) }}
      <!-- dersom vi ønsker å vise klokkeslett på localized format {{ klokkeslett | plaintime }} kan benyttes,
      men det kan skape forventning om at man kan benytte dette formatet også i inputfeltet - noe som krever mer endringer -->
      @if (innslag.varighet != null) {
        <span class="varighet">({{ innslag.varighet | duration }})</span>
      }
    </mat-option>
  }
</mat-autocomplete>
